"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'access.list.searchPlaceholder': 'Search access policies...',
};
